import React, { useEffect, useContext, useState, useReducer, useMemo } from 'react';
import axios from 'axios';
import $ from 'jquery';
import { NavLink } from 'react-router-dom';
import { LoginContext } from '../../hooks/context/LoginContext';
import Menusup from '../../componentes/menus/menusup/Menusup';
import Sidebar from '../../componentes/menus/sidebar/Sidebar';
import FormRow from '../../componentes/formulario/FormRow';
import FormInput from '../../componentes/formulario/FormInput';
import TextArea from '../../componentes/formulario/TextArea';
import Footer from '../../componentes/footer/Footer';
import Section from '../../componentes/ui/Section';
import MiDataTableRunciccfg from './MiDataTableRunciccfg';
import MiDataTableVerLineas from './MiDataTableVerLineas';
import MiSelect from '../../componentes/formulario/MiSelect';
import Button from '../../componentes/ui/Button';
import { Alert } from '../../componentes/ui/Alert';
import { alertService } from '../../services/alertservice';
import PermissionRefused from '../../componentes/ui/PermissionRefused';
import LoadingPage from '../../componentes/ui/LoadingPage';
import Modal from 'react-bootstrap/Modal';
import InformesBtn from '../../componentes/formulario/informes/informesBtn/InformesBtn';
import MiDataTable from '../../componentes/ui/MiDataTable';
import CheckIos from '../../componentes/ui/CheckIos';
import { Stepper, Step, StepLabel } from '@material-ui/core';
import StepConnector from '@material-ui/core/StepConnector';
import { withStyles } from '@material-ui/core/styles';
import Spinner from 'react-bootstrap/Spinner';
import SpinnerFloat from '../../componentes/ui/SpinnerFloat';
import useLogicForm from '../../hooks/useLogicForm';
import Cookies from 'universal-cookie';
import { Fragment } from 'react';
import Informes from "../../componentes/formulario/informes/Informes";
import { getApiUrl, axiosPost, dateFormatByLocale, getTitle, getDecodedCookie, renderTabTitle, encryptData, MiReplaceAll } from '../../helpers/helperApp';
import PendienteFirmaModalContent from './PendienteFirmaModalContent';



    let varAccion = null;
    let backUpOptionsUbi;
    let varOrigen = "";
    let lineaSelect;

    // Reducer para el estado del stepper
    const initialStepperState = {
        datosTablas: [],
        registrosSeleccionados: [],
        activeStep: 0,
        stepBtnNext: null,
        lineaSelect: null,
        idDoc: 0,
        idEstDoc: 0,
        infoDocSelectThisTable: null,
        activarBtnLanzarSolicitud: false,
        defaultAgeNextStep: null,
        cicDefAge: null, // Lo guardaremos aquí al cargar el ciclo
        numSteps: [],
        titleTabs: []
    };

function stepperReducer(state, action) {
       
    const calculateDerivedState = (newState) => {
        const { datosTablas, registrosSeleccionados, activeStep, cicDefAge } = newState;
        const index = activeStep;

        if (!registrosSeleccionados || !datosTablas) {
            return newState;
        }

        const lineaSelect = registrosSeleccionados[index] && registrosSeleccionados[index][`runciccfgTab_${index + 1}`]
            ? registrosSeleccionados[index][`runciccfgTab_${index + 1}`].split("-")[1]
            : null;

        const idDoc = lineaSelect || 0;

        const infoDocSelectThisTable = (datosTablas[index] && lineaSelect)
            ? datosTablas[index].filter((reg) => reg.id == lineaSelect)
            : null;

        let defaultAgeNextStep = cicDefAge;
        if (infoDocSelectThisTable && infoDocSelectThisTable.length > 0) {
            const found = infoDocSelectThisTable[0];
            if (found.agedef != null && found.idage2 !== '') {
                defaultAgeNextStep = found.agedef;
            }
        }

        return {
            ...newState,
            lineaSelect,
            idDoc,
            idEstDoc: infoDocSelectThisTable && infoDocSelectThisTable.length > 0 
                ? infoDocSelectThisTable[0].idest 
                : 0,
            infoDocSelectThisTable,
            activarBtnLanzarSolicitud: !!(
                infoDocSelectThisTable && 
                infoDocSelectThisTable.length > 0 && 
                infoDocSelectThisTable[0].idtip == infoDocSelectThisTable[0].tipdocreq
            ),
            defaultAgeNextStep,
        };
    };

    // --- SWITCH DE ACCIONES ---
    switch (action.type) {
        case 'SET_INITIAL_DATA': {
            // Acción para cuando cargas los datos del ciclo por primera vez
            const { datosTablas, registrosSeleccionados, titleTabs, ciclo } = action.payload;
            let tempState = {
                ...state,
                datosTablas,
                registrosSeleccionados,
                numSteps: Array.from({ length: titleTabs.length }, (_, i) => i + 1),
                cicDefAge: ciclo.cicdefage, // Guardamos el valor por defecto
                activeStep: 0,
            };
            return calculateDerivedState(tempState);
        }

        case 'SET_ACTIVE_STEP': {
            if (state.activeStep === action.payload) return state;
            let tempState = { ...state, activeStep: action.payload };
            return calculateDerivedState(tempState);
        }
        case 'HANDLE_ROW_SELECT': {
            const { idTabla, idRow, isSelected } = action.payload;
            const stepIndex = parseInt(idTabla.replace('runciccfgTab_', '')) - 1;        

            if (isSelected) {
                const newRegistrosSeleccionados = state.registrosSeleccionados.slice(0, stepIndex);
                newRegistrosSeleccionados.push({ [idTabla]: idRow });
         
                const newDatosTablas = state.datosTablas.slice(0, stepIndex + 1);
                return calculateDerivedState({
                    ...state,
                    registrosSeleccionados: newRegistrosSeleccionados,
                    datosTablas: newDatosTablas,
                });
            } else {
                //  Deselección — limpiar selecciones desde este step hacia adelante
                // pero MANTENER datosTablas intacto para que las tablas sigan visibles
                const newRegistrosSeleccionados = state.registrosSeleccionados.slice(0, stepIndex);
                return calculateDerivedState({
                    ...state,
                    registrosSeleccionados: newRegistrosSeleccionados,
                    // datosTablas NO se toca — los datos permanecen en pantalla
                    // activeStep: Math.min(state.activeStep, Math.max(0, stepIndex - 1)),
                });
            }
        }
        case 'UPDATE_STEPPER_STATE': {
            let tempState = {
                ...state,
                registrosSeleccionados: action.payload.registrosSeleccionados,
                datosTablas: action.payload.datosTablas,
                activeStep: action.payload.activeStep, 
            };
            return calculateDerivedState(tempState);
        }

        case 'SET_DATOS_TABLAS': {
            let tempState = { ...state, datosTablas: action.payload };
            return calculateDerivedState(tempState);
        } 
        case 'SET_STEP_BTN_NEXT': {
           return { ...state, stepBtnNext: action.payload };
        }
        default:
          console.warn('Acción no manejada en reducer:', action.type)
            return state;
    }
}

function RunCicCfg(props){

    const cookies = new Cookies();
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    // ***** Custom Hook - Lógica de los formularios *****
    const { registrosPrin, saveRegistrosPrin, formularioPrin, saveFormularioPrin, adjuntosPrin, saveAdjuntosPrin, adjuntosExistentesPrin, saveAdjuntosExistentesPrin, registrosHijo,  formularioHijo, saveFormularioHijo, adjuntosHijo, saveAdjuntosHijo, adjuntosExistentesHijo, saveAdjuntosExistentesHijo, handleInputForm, handleLastReg, handleEditRegPrin, loadingTable, saveLoadingTable, loadReg, regIniciales, handleEditRegHijo, handleDeleteItemPrin, handleDeleteItemHijo, handleSubmitPrin, handleSubmitHijo, resetFormPrin, resetFormHijo, handleSelectFormPrin, handleSelectMultipleFormPrin } = useLogicForm();

    // ***** Context *****
    const { validateSesion, socket, confApp, saveConfApp, getConfApp, apiKey, logo, appCryptCom, cicDefAge } = useContext(LoginContext);    

    // ***** State para la configuración de la pantalla *****
    const [ confPantalla, saveConfPantalla ] = useState(confApp)
    const [ loadedConf, saveLoadedConf ] = useState(false);
    const [ tieneNivel, saveTieneNivel ] = useState(true);
    const [ idCiclo, saveIdCiclo ] = useState("");
    const [ loadingCiclo, saveLoadingCiclo ] = useState(true);
    const [ ciclo, saveCiclo ] = useState([]);
    const [ showModal, saveShowModal ] = useState(false);
    const [ idNuevoCiclo, saveIdNuevoCiclo ] = useState(0);
    const [ loadingNuevoCiclo, saveLoadingNuevoCiclo ] = useState(false);
    const [ numSteps, saveNumSteps ] = useState([]);
    const [ titleTabs, saveTitleTabs ] = useState([]);
    const [ forceBtnNext, saveForceBtnNext ] = useState(0);
    const [ columnasModalLineas, saveColumnasModalLineas ] = useState([]);
    
    // Reducer para el estado del stepper
    const [stepperState, stepperDispatch] = useReducer(stepperReducer, initialStepperState);
    const { registrosSeleccionados, datosTablas, activeStep, stepBtnNext } = stepperState;
    
    // Funciones helper para mantener compatibilidad con el código existente
    const saveRegistrosSeleccionados = (data) => {
        if (typeof data === 'function') {
            // Si es una función, obtener el valor actual y aplicarla
            data = data(stepperState.registrosSeleccionados);
        }
        stepperDispatch({ type: 'SET_REGISTROS_SELECCIONADOS', payload: data });
    };
   
    const saveActiveStep = (data) => stepperDispatch({ type: 'SET_ACTIVE_STEP', payload: data });
    const saveStepBtnNext = (data) => stepperDispatch({ type: 'SET_STEP_BTN_NEXT', payload: data });
    
    // Función para actualizar todos los estados del stepper simultáneamente
    const updateStepperState = (registros, datos, active) => {
        stepperDispatch({
            type: 'UPDATE_STEPPER_STATE',
            payload: {
                registrosSeleccionados: registros,
                datosTablas: datos,
                activeStep: active
            }
        });
    };
    
    const [ showModalNextStep, saveShowModalNextStep ] = useState(false);
    const [ loadingModalNextStep, saveLoadingModalNextStep ] = useState(false);
    const [ infoModalNextStep, saveInfoModalNextStep ] = useState({opt: 0, divi: 0, apl: 0});
    const [ tablaModalNextStep, saveTablaModalNextStep ] = useState();
    const [ txtModalDocs, saveTxtModalDocs ] = useState(null);
    // Estados ahora manejados por el reducer stepperReducer
    // (registrosSeleccionados, datosTablas, activeStep, stepBtnNext)
    
    const [ cantidadEdi, saveCantidadEdi ] = useState([]);
    const [ ubicacionesEdi, saveUbicacionesEdi ] = useState([]);
    const [ revisadoEdi, saveRevisadoEdi ] = useState([]);
    const [ showModalLineas, saveShowModalLineas ] = useState(false); 
    const [ tablaLineas, saveTablaLineas ] = useState([]);
    const [ loadingTablaLineas, saveLoadingTablaLineas ] = useState(false);
    const [ renderedTitleTabs, saveRenderedTitleTabs ] = useState([]);
    const [ pasoTablaVerLineas, savePasoTablaVerLineas ] = useState(null);
    const [ showModalResponsable, saveShowModalResponsable ] = useState(false);
    const [ valResponsable, saveValResponsable ] = useState(0);
    const [ idDocUpdateResponsable, saveIdDocUpdateResponsable ] = useState(0);
    const [ loadingUpdateResponsable, saveLoadingUpdateResponsable ] = useState(false);
    const [ showModalInfoOperacion, saveShowModalInfoOperacion ] = useState(false);    
    const [ datosTablaInfoOperacion, saveDatosTablaInfoOperacion ] = useState([]);
    const [ loadingTablaInfoOperacion, saveLoadingTablaInfoOperacion ] = useState([]);
    const [ showModalPendienteFirma, saveShowModalPendienteFirma ] = useState(false);
    const [ pendienteFirmaContext, savePendienteFirmaContext ] = useState({ paso: null, divisible: null, apilable: null });
    const [ codCic, saveCodCic ] = useState("");
    const [ infoCiclo, saveInfoCiclo ] = useState([]);
    const [ optionsUbi, saveOptionsUbi ] = useState(null);
    const [ loadedSelect, saveLoadedSelect ] = useState(false);
    const [ valModalResponsable, saveValModalResponsable ] = useState(0);
    const [ valModalCentro, saveValModalCentro ] = useState(0);
    const [ valModalDescripcion, saveValModalDescripcion ] = useState("");
    const [ valModalIncludeCero, saveValModalIncludeCero ] = useState(false);
    const [ idDocInformesModalNextStep, saveIdDocInformesModalNextStep ] = useState(0); 
    
  
    const QontoConnector = withStyles({
        alternativeLabel: {
            top: 10,
            left: 'calc(-50% + 16px)',
            right: 'calc(50% + 16px)',
        },
        active: {
            '& $line': {
            borderColor: '#4caf50',
            },
        },
        completed: {
            '& $line': {
            borderColor: '#4caf50',
            },
        },
        line: {
            borderColor: '#eaeaf0',
            borderTopWidth: 3,
            borderRadius: 1,
        },
    })(StepConnector);

    const keyframesStyle = `@keyframes bounce {
        0%, 100% { transform: translateY(0); }
       50% { transform: translateY(-10px); }
     }`;

    const ColoredStepIcon = ({ color, index, isActive }) => (
        <div style={{
            width: 24,
            height: 24,
            borderRadius: '50%',
            backgroundColor: color || '#007bff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff',
            fontSize: 12,
            fontWeight: 'bold',
            animation: isActive ? 'bounce 1s infinite' : 'none',
            boxShadow: isActive ? '0 0 0 4px rgba(0, 123, 255, 0.3)' : 'none'
        }}>
            {index + 1}
        </div>
    );
    useEffect( () => {        
        
        // ***** Validamos que el usuario esté logueado sino lo enviamos al login*****
        validateSesion(props)
            .then( (respuesta) => {
                if( confPantalla === undefined ){
                    return getConfApp();
                }else{                             
                    document.title = getTitle(confPantalla.config.trad, confPantalla.runciccfg.title);                               
                    if( respuesta == 1 ){
                        saveTieneNivel(true);
                        saveLoadingCiclo(false)
                        if( props.location.state ){                                                                              
                            if( "idCic" in props.location.state && "idDoc" in props.location.state && "idCen" in props.location.state && "idAge2" in props.location.state ){
                                // Crear y seleccionar
                                varOrigen = props.location.state.origen;
                                autoIniciar(props.location.state.idCic, props.location.state.idDoc, props.location.state.idCen, props.location.state.idAge2, props.location.state.nom1, props.location.state.includecero, props.location.state.origen);
                            }else if( "idDoc" in props.location.state ){
                                // Seleccionar                                
                               autoIniciarFull(props.location.state.idDoc);
                            }                        
                        }
                    }
                    else if( respuesta == 0 ){
                        saveTieneNivel(false);
                    }                    
                    saveLoadedConf(true);        
                }
            })
            .then( (respuesta) => {
                if( respuesta !== undefined  ){
                    saveConfPantalla(respuesta.msg);
                    saveConfApp(respuesta.msg);             
                }
            })            

        // Liberamos todos los registros al salir de la pantalla
        return () =>{
            if( socket != null ){
                socket.emit("salirPantalla", { "idciccfg": getDecodedCookie('id'), "tabla": "undefined" })
            }
            document.querySelector("body").classList.remove("sidebar-open");
            // Token cancelación axios al desmontar componentes
            source.cancel();    
        }         
        
    },[confPantalla])

    useEffect(() => {
        if (confPantalla?.runciccfg?.padre?.datatablemodallineas?.datatable?.columns) {
            const idioma = getDecodedCookie('idioma');
            const campoDescripcion = idioma === 'en' ? 'descripcionlin_en' : 'descripcionlin';
            
            const cols = [...confPantalla.runciccfg.padre.datatablemodallineas.datatable.columns];
            
            cols.splice(1, 0, {
                title: 'Descripción',
                data: campoDescripcion,
                width: '350px'
            });
            
            saveColumnasModalLineas(cols);
        }
    }, [confPantalla]);

    const autoIniciar = async (idCicloParam, idDocParam, idCenParam, idAge2Param, nom1Param, includeCeroParam, origenParam) => {
        await loadOptionsCbo(confPantalla.runciccfg.padre.datatablemodallineas.ubi.datatype, confPantalla.runciccfg.padre.datatablemodallineas.ubi.data, optionsUbi, saveOptionsUbi);

        saveLoadingNuevoCiclo(true);    

        saveIdCiclo(idCicloParam);
        await getCicloEnCurso(idCicloParam);                
        const idAutoSelect = await nuevoCiclo(idCicloParam, idDocParam, idCenParam, idAge2Param, MiReplaceAll(nom1Param, "||", "/"), includeCeroParam, origenParam); 
        await getCicloEnCurso(idCicloParam, idAutoSelect);  

        // Seleccionar
        let auxRegistrosSeleccionados = [];        
        const datosAux = { ["runciccfgTab_1"] : `#row-${idAutoSelect}` };
        auxRegistrosSeleccionados.push(datosAux);
        saveRegistrosSeleccionados(auxRegistrosSeleccionados)         
        
        await autoIniciarFull(idAutoSelect, auxRegistrosSeleccionados, false, true);

        saveLoadingNuevoCiclo(false);
        saveLoadingCiclo(false);    
    }

    const autoIniciarFull = async (idDoc, auxRegistrosSeleccionadosParam=null, returnData=false, fromAutoIniciar=false) =>{        
        saveLoadingNuevoCiclo(true);

        if(fromAutoIniciar == false || fromAutoIniciar == null){
            await loadOptionsCbo(confPantalla.runciccfg.padre.datatablemodallineas.ubi.datatype, confPantalla.runciccfg.padre.datatablemodallineas.ubi.data, optionsUbi, saveOptionsUbi);
        }

        // Obtener todos los ids de documentos del ciclo, sus paso ordenados y el id del ciclo para el siguiente paso, getciclo
        const data = new FormData();      
        data.append("validacion", apiKey());
        data.append("iddoc", idDoc);
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.runciccfg.padre.getalldocsciclo, data, source.token);        
        if( typeof respuesta.data == "string"){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});
            return; 
        }    

        let auxDatosTablas = []; 
        let auxRegistrosSeleccionados = [];
        
        saveInfoCiclo(respuesta.data);         
        if(respuesta.data.length > 0){            
            saveIdCiclo(respuesta.data[0].idcic);
            saveCodCic(respuesta.data[0].codcic);            
            const docIniCiclo = respuesta.data[0].idori;
           
            // Obtnemos el ciclo para el select y la info de los tabs
            await getCicloEnCurso(respuesta.data[0].idcic, idDoc);

            // Obtnemos los datos de las tablas            
            if(auxRegistrosSeleccionadosParam != null){
                auxRegistrosSeleccionados = auxRegistrosSeleccionadosParam;
            }
             
            // Tabla primer paso
            const auxDatosTableFirst = await getDatosTable(respuesta.data[0].idcic, true);
            if(auxDatosTableFirst.length > 0){
                auxDatosTablas.push(auxDatosTableFirst);
                if(!auxRegistrosSeleccionados.some(obj => obj.hasOwnProperty('runciccfgTab_1'))){
                    auxRegistrosSeleccionados.push({ [`runciccfgTab_1`] : `#row-${docIniCiclo}` });
                }
            }
            
            // Resto de tablas           
            let numPasos;
            for (let i = 0; i < respuesta.data.length; i++) {
                if (respuesta.data[i].iddoc != 0) {
                    numPasos = respuesta.data[i].ord;                    
                }
            }
            let pasosNext = [];                                  
            for(let i=1; i < numPasos; i++){
                    pasosNext.push(i);
            }            
            const dataTableNext = await getDatosTableNextStep(respuesta.data[0].idcic, null, auxRegistrosSeleccionados, pasosNext);            
            for(let i=0; i < dataTableNext.length; i++){                                          
                auxDatosTablas.push(dataTableNext[i]);
                if(!auxRegistrosSeleccionados.some(obj => obj.hasOwnProperty(`runciccfgTab_${i+2}`))){
                    auxRegistrosSeleccionados.push({ 
                        [`runciccfgTab_${i+2}`]: `#row-${dataTableNext[i][0].id}`,
                        [`idest_${i+2}`]: dataTableNext[i][0].idest,
                        [`est_${i+2}`]: dataTableNext[i][0].esttab
                    });                
                }                                                            
            }

            // Seleccionamos el que llegar por parámetro
            let numTab = 0;
            for(let x=0; x<respuesta.data.length; x++){                    
                if(respuesta.data[x].iddoc == idDoc){
                    numTab = respuesta.data[x].ord;
                    auxRegistrosSeleccionados[respuesta.data[x].ord-1][`runciccfgTab_${respuesta.data[x].ord}`] = `#row-${idDoc}`;                                   
                }
            }
                        
            // saveRegistrosSeleccionados(auxRegistrosSeleccionados);
            // saveDatosTablas(auxDatosTablas);
            updateStepperState(auxRegistrosSeleccionados, auxDatosTablas, numTab > 0 ? numTab - 1 : 0);
            // Ir al tab del documento que llegó por parámetro
            const linkTab = document.getElementById(`tab1-tab-tab_${numTab}`);            
            if(linkTab){
                linkTab.click();
            }            
        }

        saveLoadingNuevoCiclo(false);
        if(returnData){
            return [auxDatosTablas, auxRegistrosSeleccionados];
        }
    }

    const handleSelect= (selectedItem, nameOfComponent, saveData, setDescripcion=false) => {        
        if( selectedItem ){
            saveData(selectedItem.value)
            if(setDescripcion == true){                
                saveValModalDescripcion(selectedItem.labelnohtml); 
            }
        }else{
            saveData(0)
            if(setDescripcion == true){                
                saveValModalDescripcion(""); 
            }
        }
    }
    
   const handleSelectCiclo = async (selectedItem, nameOfComponent) => {
        if(selectedItem) {
            await getCicloEnCurso(selectedItem.value);
            const datos = await getDatosTable(selectedItem.value);
            
            updateStepperState([], [datos], 0);
            saveIdCiclo(selectedItem.value);
        } else {
            saveIdCiclo("");
            saveCiclo([]);
            updateStepperState([], [], 0);
        }
    }

    const handleSelectResponsable = (selectedItem, nameOfComponent) => {
        if( selectedItem ){
            saveValResponsable(selectedItem.value) 
        }else{
            saveValResponsable(0)
        }
    }

    const showModalFn = async () => {
        saveShowModal(true);
        saveIdNuevoCiclo(0);
        saveValModalCentro(0);
        saveValModalDescripcion("");
        saveValModalIncludeCero(false);

        // Obtener responsable por defecto del backend
        if (idCiclo && idCiclo !== "") {
            try {
                const data = new FormData();
                data.append("validacion", apiKey());
                data.append("idCic", idCiclo);
                const res = await axiosPost(getApiUrl(window.location.origin) + '/agentes/getResponsibleByCicId', data, source.token);
                if (res.data.success && res.data.data && res.data.data.length > 0) {
                    saveValModalResponsable(res.data.data[0].id);
                } else {
                    saveValModalResponsable(cicDefAge);
                }
            } catch (error) {
                console.error('Error obteniendo responsable:', error);
                saveValModalResponsable(cicDefAge);
            }
        } else {
            saveValModalResponsable(cicDefAge);
        }
    }
    
    const getCicloEnCurso = async (idCiclo, idAutoSelect=null) => {    

        saveLoadingCiclo(true);
        
        const data = new FormData();      
        data.append("validacion", apiKey());
        data.append("idciclo", idCiclo);
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.runciccfg.padre.getciclo, data, source.token);
        if( typeof respuesta.data == "string"){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true}); 
        }else{            
            saveNumSteps(getLengthCiclo(respuesta.data.ciclo[0].numsteps));
            saveCiclo(respuesta.data.ciclo[0]);
            saveTitleTabs(respuesta.data.titletabs);              
            saveRenderedTitleTabs(await renderTabTitle(respuesta.data.titletabs, respuesta.data.titletabs.length, idAutoSelect));         
        }
        saveLoadingCiclo(false);

    }

    const getLengthCiclo = (steps) => {
        let data = [];
        for(let i=0; i<steps; i++){
            data.push(i);
        }
        return data;
    }

    const getDatosTable = async (idCiclo) => {
        saveLoadingCiclo(true);
        
        const data = new FormData();
        data.append("validacion", apiKey());
        data.append("idciclo", idCiclo);
        const respuesta = await axiosPost(
            getApiUrl(window.location.origin) + confPantalla.runciccfg.padre.getdatostable, 
            data, 
            source.token
        );

        saveLoadingCiclo(false);

        if(typeof respuesta.data == "string"){
            alertService.error(
                `<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, 
                {autoClose: true}
            );
            return [];
        }

        return respuesta.data; 
    }

    const nuevoCiclo = async (idCicloParam=null, idNuevoCicloParam=null, idCenParam=null, idAge2Param=null, nom1Param=null, includeCeroParam=null, origen=null) => {            
        if(idCicloParam != null) saveLoadingCiclo(true);  
        saveLoadingNuevoCiclo(true);
        const data = new FormData();      
        data.append("validacion", apiKey());
        data.append("idciclo", idCicloParam != null ? idCicloParam : idCiclo);
        data.append("idnuevociclo", idNuevoCicloParam != null ? idNuevoCicloParam: idNuevoCiclo);        
        data.append("idage2", idAge2Param != null ? idAge2Param : valModalResponsable);
        data.append("idcen", idCenParam != null ? idCenParam : valModalCentro);
        data.append("nom1", nom1Param != null ? nom1Param : valModalDescripcion);
        data.append("includecero", includeCeroParam != null ? includeCeroParam : valModalIncludeCero);
        data.append("origenciclo", origen);
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.runciccfg.padre.createInitCiclo.getdata, data, source.token);
        saveShowModal(false);

        if( typeof respuesta.data == "string"){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true}); 
            saveLoadingNuevoCiclo(false);
            return 0;
        }else{
            if(respuesta.data.showSuccess == true){
                alertService.success(`<i class="fal fa-times-octagon mr-1"></i>${confPantalla.runciccfg.padre.createInitCiclo.success.title}`, {autoClose: true});
            }
            if(idCicloParam == null){
                await getDatosTable(idCiclo);
                const auxRegistrosSeleccionados = [{ ["runciccfgTab_1"]: `#row-${respuesta.data.id}` }];
                saveRegistrosSeleccionados(auxRegistrosSeleccionados); 
                await autoIniciarFull(respuesta.data.id, auxRegistrosSeleccionados, false, false);
                saveLoadingNuevoCiclo(false);          
            }            
            saveIdCiclo(idCicloParam != null ? idCicloParam : idCiclo)            
            saveRenderedTitleTabs(await renderTabTitle(titleTabs, titleTabs.length, respuesta.data.id)); 
            saveLoadingNuevoCiclo(false);
            return respuesta.data.id;    
        }
    }

    const getHeaderModalNextStep = () => {        
        const info = $(".runciccfgTab_"+stepBtnNext).DataTable().rows( { selected: true } ).data()[0];
        let txtEquipo = "";
        let txtDesc = "";
        if(info && info.length > 0){
            txtEquipo = info.equitab != "" && info.equitab ? info.equitab+" - " : "";
            txtDesc = info.descripcion;
        }
        const h5 = <div className="col-12">
                   {/* <div className="col-md-10 offset-1" > */}
                        <div className="alert alert-secondary alertHelp text-center" role="alert" style={{margin: "0px"}}>
                            <div className="flex-center">
                                <div className="col-2" style={{display: "flex", justifyContent: "left"}}>
                                    <h5 style={{marginBottom : "0px"}}>
                                        {confPantalla.runciccfg.padre.helpmodal.pasoactual.title} {stepBtnNext}/{numSteps.length}:                                  
                                        <span dangerouslySetInnerHTML={{ __html: txtEquipo+txtDesc }} />
                                    </h5>
                                </div>
                                <div className="col-8" style={{display: "flex", justifyContent: "center"}}>
                                    {getTxtHelp(null, null, null, null, true, false)}
                                </div>
                                <div className="col-2" style={{display: "flex", justifyContent: "right"}}>
                                    <p 
                                        className={ infoModalNextStep.opt == 0 ? "text-danger text-center mr-2"  : "text-success text-center mr-2" } 
                                        style={{marginBottom : "0px"}}>
                                        {confPantalla.runciccfg.padre.helpmodal.opcional.title}                                     
                                    </p>
                                    <p 
                                        className={ infoModalNextStep.divi == 0 ? "text-danger text-center mr-2"  : "text-success text-center mr-2" } 
                                        style={{marginBottom : "0px"}}>
                                        {confPantalla.runciccfg.padre.helpmodal.divisible.title}                                     
                                    </p>
                                    <p 
                                        className={ infoModalNextStep.apl == 0 ? "text-danger text-center mr-2"  : "text-success text-center mr-2" } 
                                        style={{marginBottom : "0px"}}>
                                        {confPantalla.runciccfg.padre.helpmodal.apilable.title}                                   
                                    </p>
                                </div>
                            </div>                           
                        </div>
                    </div>;
        return h5;
    }

    const getTxtHelp = (idRow, id, datos, selectedRows, getSelected=false, returnAlert=true) =>{                 
        if(getSelected){
            let help = null;
            selectedRows = $('#tableModalDocs').DataTable().rows( { selected: true } ).data();
            let txtEquipo = "";
            let txtDesc = "";
            if(selectedRows.length > 0){
                txtEquipo = selectedRows[0]["equitab"] != "" && selectedRows[0]["equitab"] ? selectedRows[0]["equitab"]+" - " : "";
                txtDesc = selectedRows[0]["descripcion"];
            }

            if(returnAlert == true){
                selectedRows.length == 0 
                ?
                    help =  <div className="alert alert-success mt-1" role="alert" style={{width : "fit-content"}}>
                                <h5 style={{marginBottom : "0px"}}>{confPantalla.runciccfg.padre.helpmodal.crear.title}</h5>
                            </div>
                :
                    help = <div className="alert alert-primary mt-1" role="alert" style={{width : "fit-content"}}>
                                <h5 style={{marginBottom : "0px"}}>{confPantalla.runciccfg.padre.helpmodal.editar.title+" "}                                
                                    <span style={{fontWeight: "700"}} dangerouslySetInnerHTML={{ __html: txtEquipo+txtDesc }} />
                                </h5>
                            </div>
                return help;
            }else{
                selectedRows.length == 0 
                ?
                    help = <h5 className="text-success " >{confPantalla.runciccfg.padre.helpmodal.crear.title}</h5>
                :
                    help = <h5 className="text-primary " >{confPantalla.runciccfg.padre.helpmodal.editar.title+" "}
                                <span style={{fontWeight: "700"}} dangerouslySetInnerHTML={{ __html: txtEquipo+txtDesc }} />
                           </h5>
                           
                return help;
            }
        }else{
            let txtEquipo = "";
            let txtDesc = "";
            if(selectedRows.length > 0){
                txtEquipo = selectedRows[0]["equitab"] != "" && selectedRows[0]["equitab"] ? selectedRows[0]["equitab"]+" - " : "";
                txtDesc = selectedRows[0]["descripcion"];
            }
            saveTxtModalDocs(selectedRows.length == 0 
                            ?                             
                                <div className="alert alert-success mt-1" role="alert" style={{width : "fit-content"}}>
                                    <h5 style={{marginBottom : "0px"}}>{confPantalla.runciccfg.padre.helpmodal.crear.title}</h5>
                                </div>  
                            : 
                                <div className="alert alert-primary mt-1" role="alert" style={{width : "fit-content"}}>
                                    <h5 style={{marginBottom : "0px"}}>{confPantalla.runciccfg.padre.helpmodal.editar.title+" "}
                                        <span style={{fontWeight: "700"}} dangerouslySetInnerHTML={{ __html: txtEquipo+txtDesc }} />
                                    </h5>
                                </div>                                                    
                            )
        }

    }

    const getStepColor = (idest, estado) => {    
        const est = parseInt(idest);
        if (estado === 'EN CURSO') return '#ffc107';
        if (estado === 'FINALIZADO' || estado === 'REALIZADO') return '#28a745';
        if (estado === 'NO REALIZADO' || estado === 'PENDIENTE FIRMA') return '#f58442';
        if(estado == 'RECHAZADO') return '#dc3545';
     
        return '#007bff';
    };

    const stepColors = useMemo(() => {
        if (!numSteps.length) return [];

        return numSteps.map((_, index) => {
            const regEntry = registrosSeleccionados[index];
            if (!regEntry) return '#007bff';

            const idest = regEntry[`idest_${index + 1}`];
            const est = regEntry[`est_${index + 1}`];
        
            if (idest !== undefined) return getStepColor(idest, est);

            // Fallback: buscar en tabla si está cargada
            const rowValue = regEntry[`runciccfgTab_${index + 1}`];
            if (!rowValue) return '#007bff';
            const stepLineaSelect = rowValue.split("-")[1];
            if (!stepLineaSelect) return '#007bff';

            const tabla = datosTablas[index];
            if (!tabla || !tabla.length) return '#007bff';

            const found = tabla.find(reg => String(reg.id) === String(stepLineaSelect));   
                
            return found ? getStepColor(found.idest, found.esttab) : '#007bff';
        });
    }, [registrosSeleccionados, datosTablas, numSteps]);

    const handleStepClick = async (step) => {
        const selectedReg = registrosSeleccionados[step]?.[`runciccfgTab_${step + 1}`];
        if (!selectedReg) {
            alertService.error(`...`, {autoClose: true});
            return;
        }

        if (!datosTablas[step] || datosTablas[step].length === 0) {
            saveLoadingCiclo(true);
            const data = await getDatosTableNextStep(idCiclo, step + 1, registrosSeleccionados);
            const aux = [...datosTablas];
            aux[step] = data;
            // Actualizar tablas Y activeStep atómicamente
            updateStepperState(registrosSeleccionados, aux, step);
            saveLoadingCiclo(false);
        } else {
            // Solo cambiar el step activo
            saveActiveStep(step);
        }
    };
    
    const nextStep = async (step, defaultAgeNextStep) => {
        // Guarda para evitar errores si no hay nada seleccionado
        const currentStepSelection = registrosSeleccionados[step - 1];
        if (!currentStepSelection || !currentStepSelection[`runciccfgTab_${step}`]) {
            alertService.warn(`<i class="fal fa-exclamation-triangle mr-1"></i>Por favor, selecciona un registro para continuar.`, { autoClose: true });
            return;
        }            
        saveStepBtnNext(step);        
        saveCantidadEdi([]); // Reiniciamos el array que donde almacenamos los valores cuando editamos la cantidad en el modal
        saveUbicacionesEdi([]);
        saveRevisadoEdi([]);
        // Obtener responsable por defecto del backend
        if (idCiclo && idCiclo !== "") {
            try {
                const dataAge = new FormData();
                dataAge.append("validacion", apiKey());
                dataAge.append("idCic", idCiclo);
                dataAge.append("step", (step));
                const resAge = await axiosPost(getApiUrl(window.location.origin) + '/agentes/getResponsibleByCicId', dataAge, source.token);
                if (resAge.data.success && resAge.data.data && resAge.data.data.length > 0) {
                    saveValResponsable(resAge.data.data[0].id);
                } else {
                    saveValResponsable(defaultAgeNextStep);
                }
            } catch (error) {
                console.error('Error obteniendo responsable:', error);
                saveValResponsable(defaultAgeNextStep);
            }
        } else {
            saveValResponsable(defaultAgeNextStep);
        }
        if(numSteps.length == step){  
            saveLoadingCiclo(true);

            const idDoc = registrosSeleccionados
                .filter((reg) => Object.keys(reg)[0] == "runciccfgTab_"+step)[0]
                ["runciccfgTab_"+step].split("-")[1];            
            
            const data = new FormData();      
            data.append("validacion", apiKey());
            data.append("iddoc", idDoc);               
            const respuesta = await axiosPost(
                getApiUrl(window.location.origin) + confPantalla.runciccfg.padre.finalizarciclo, 
                data, 
                source.token
            );
                        
            if( typeof respuesta.data == "string"){
                alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});                 
            } else {                
                // Recargar tabla del último paso
                const aux = [...datosTablas];
                const dataTableActual = await getDatosTableNextStep(idCiclo, step - 1, registrosSeleccionados);
                aux[step - 1] = dataTableActual;

                // Actualizar idest del último step en auxRegistrosSeleccionados
                let auxRegistrosSeleccionados = [...registrosSeleccionados];
                if(dataTableActual && dataTableActual.length > 0){
                    const docActualizado = dataTableActual.find(r => String(r.id) === String(idDoc));
                    if(docActualizado){
                        auxRegistrosSeleccionados[step - 1] = {
                            ...auxRegistrosSeleccionados[step - 1],
                            [`idest_${step}`]: docActualizado.idest,
                            [`est_${step}`]: docActualizado.esttab
                        };
                    }
                }

                // Dispatch atómico manteniendo el activeStep actual
                updateStepperState(auxRegistrosSeleccionados, aux, activeStep);
            }

            saveLoadingCiclo(false);
        }else{                    
            saveLoadingModalNextStep(true);
            saveTablaModalNextStep([]);
            saveInfoModalNextStep({opt: 0, divi: 0, apl: 0});
            getTxtHelp(null, null, null, [])
            const idDoc = registrosSeleccionados.filter((reg) => Object.keys(reg)[0] == "runciccfgTab_"+step)[0]["runciccfgTab_"+step].split("-")[1];
            const est = registrosSeleccionados.filter((reg) => Object.keys(reg)[0] == "runciccfgTab_"+step)[0]["est_"+step];
       
            saveIdDocInformesModalNextStep(idDoc);
            const data = new FormData();      
            data.append("validacion", apiKey());
            data.append("step", step+1);
            data.append("iddoc", idDoc);
            data.append("idciclo", idCiclo);
    
            // Obtenemos la configuración(DIVISIBLE, APILABLE, OPCIONAL)
            
            const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.runciccfg.padre.getinfomodalnextstep, data, source.token);       
            if( typeof respuesta.data == "string"){
                alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true}); 
            }else{
                saveInfoModalNextStep(respuesta.data[0]);
                
                // Acciones según su configuración(DIVISIBLE, APILABLE, OPCIONAL)
                await actionsByConf(respuesta.data[0].opt, respuesta.data[0].divi, respuesta.data[0].apl, step, est);                                     
            }
            
            saveLoadingModalNextStep(false);
        }
    }

    const actionsByConf = async (opcional, divisible, apilable, paso, est) => {  

        // Opcional sacarlo tratarlo aparte. Si es opcional me salto
        switch (divisible + '' + apilable) {
            case '00':  // NO divisible, NO apilable
                if(est === 'PENDIENTE FIRMA'){ 
                    savePendienteFirmaContext({ paso, divisible, apilable });
                    saveShowModalPendienteFirma(true);
                }else{
                    // Consultamos si hay documentos en la tabla siguiente, si hay quiere decir que existe un paso sino creamos el documento del siguiente paso
                    const existeDocSiguiente = $(".runciccfgTab_"+(paso+1)).DataTable().rows().data();
                    if(existeDocSiguiente.length > 0){
                        alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${confPantalla.runciccfg.padre.existedoc.title}`, {autoClose: false});
                    }else{
                        // Creamos el documento siguiente
                        okNextStepModal(null, paso, false);
                    }
                }
              break;
            case '01':
                if(est === 'PENDIENTE FIRMA'){ 
                    savePendienteFirmaContext({ paso, divisible, apilable });
                    saveShowModalPendienteFirma(true);
                }else{
                    // Creamos el documento siguiente independientemente de si hay documento o no
                    okNextStepModal(null, paso, false);   
                }                            
              break;
            case '10':  // SI divisible, NO apilable
                if(est === 'PENDIENTE FIRMA'){ 
                    savePendienteFirmaContext({ paso, divisible, apilable });
                    saveShowModalPendienteFirma(true);
                }else{
                  // Nos traemos las lineas, para la tabla de lineas del modal, que NO aparezcan en documentos del siguiente paso
                    const dataTableLineasModal = await getTablaModalLineas(idCiclo, paso, registrosSeleccionados, true); 
                    if(dataTableLineasModal.length == 0){
                        alertService.warn(`<i class="fal fa-times-octagon mr-1"></i>${confPantalla.runciccfg.padre.nolineaspendientesenpaso.title}`, {autoClose: false});
                            // Ir al tab del documento que llegó por parámetro
                        const linkTab = document.getElementById(`tab1-tab-tab_${paso+1}`);            
                        if(linkTab){
                            linkTab.click();
                        } 
                    }else{
                        saveShowModalNextStep(true);
                        saveTablaModalNextStep(dataTableLineasModal);                                
                    }  
                }               
                                                  
              break;
            case '11':  // SI divisible, SI apilable
                if(est === 'PENDIENTE FIRMA'){ 
                    savePendienteFirmaContext({ paso, divisible, apilable });
                    saveShowModalPendienteFirma(true);
                }else{
                    // Nos traemos TODAS las lineas, para la tabla de lineas del modal
                    const dataTableLineasModalDiviApl = await getTablaModalLineas(idCiclo, paso, registrosSeleccionados, false);                            
                    if(dataTableLineasModalDiviApl.length == 0){
                        alertService.warn(`<i class="fal fa-times-octagon mr-1"></i>${confPantalla.runciccfg.padre.nolineaspendientesenpaso.title}`, {autoClose: false});
                        // Ir al tab del documento que llegó por parámetro
                        const linkTab = document.getElementById(`tab1-tab-tab_${paso+1}`);            
                        if(linkTab){
                            linkTab.click();
                        } 
                    }else{
                        saveShowModalNextStep(true);
                        saveTablaModalNextStep(dataTableLineasModalDiviApl);                                
                    } 
                }             
                break;                      
          }

    }

    const okNextStepModal = async (e, pasoNext=null, showModal=null) => {            
        let continuar = true;
        let idActualizar = null;
        let selectedLines = null;
        let docActualizar = null;
        let auxSelectedLines = [];
        let filtrarLineas;
        let cerrarModal = true;        
        if( ((infoModalNextStep.divi == "1" && infoModalNextStep.apl == "0") || (infoModalNextStep.divi == "1" && infoModalNextStep.apl == "1")) && showModal == null ){
            selectedLines = $('#tableModalLineas').DataTable().rows( { selected: true } ).data();
            if( selectedLines.length == 0 ){
                alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${confPantalla.runciccfg.padre.selectlineas.title}`, {autoClose: true})
                continuar = false;
            }else{
                docActualizar = $('#tableModalDocs').DataTable().rows( { selected: true } ).data();
                docActualizar.length > 0 ? idActualizar = docActualizar[0].id : idActualizar = null;
                for(let i=0; i<selectedLines.length; i++){
                    auxSelectedLines.push(selectedLines[i].id);
                }                
            }
            if( infoModalNextStep.divi == "1" && infoModalNextStep.apl == "0" ){
                filtrarLineas = true;
            }else if(infoModalNextStep.divi == "1" && infoModalNextStep.apl == "1"){
                filtrarLineas = false;
            }
            cerrarModal = false;
        }

        if(continuar){
            saveLoadingCiclo(true);

            // pasoNext = paso ACTUAL (base 1) desde el que salimos
            !pasoNext ? pasoNext = stepBtnNext : pasoNext = pasoNext;

            // siguientePaso = paso al que VAMOS (base 1)
            const siguientePaso = pasoNext + 1;
            // siguienteIndex = índice base 0 del step al que vamos
            const siguienteIndex = siguientePaso - 1;

            // idDoc del paso actual, necesario para clonar y como referencia
            const idDocPasoActual = registrosSeleccionados
                .filter((reg) => Object.keys(reg)[0] == "runciccfgTab_" + pasoNext)[0]
                ["runciccfgTab_" + pasoNext].split("-")[1];

            if(showModal == false){
                varAccion = 3;
            }else{
                if(idActualizar == null){
                    varAccion = 4;
                }else{
                    varAccion = 5;
                }
            }
        
            const data = new FormData();      
            data.append("validacion", apiKey());
            data.append("idciclo", idCiclo);
            data.append("idclonar", idDocPasoActual);
            data.append("step", pasoNext);
            data.append("showmodal", showModal);
            data.append("cantidades", JSON.stringify(filterCantidadEdi(cantidadEdi, auxSelectedLines)));
            data.append("ubicaciones", JSON.stringify(filterUbicacionesEdi(ubicacionesEdi, auxSelectedLines)));
            data.append("idage2", valResponsable);
            if(idActualizar){
                data.append("idactualizar", idActualizar);
            }
            if(selectedLines){
                data.append("selectedlines", JSON.stringify(auxSelectedLines));
            }

            const respuesta = await axiosPost(
                getApiUrl(window.location.origin) + confPantalla.runciccfg.padre.createnextdoc, 
                data, 
                source.token
            );
            saveShowModal(false);

            if( typeof respuesta.data == "string"){
                alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true}); 
                saveLoadingCiclo(false);
                return;
            }

            alertService.success(`<i class="fal fa-times-octagon mr-1"></i>${confPantalla.runciccfg.padre.createInitCiclo.success.title}`, {autoClose: true});
            saveIdDocUpdateResponsable(respuesta.data.iddoc);
            saveRenderedTitleTabs(await renderTabTitle(titleTabs, titleTabs.length, respuesta.data.iddoc));  

            const aux = [...datosTablas];

         
            if(pasoNext === 1){
                const dataTableActual = await getDatosTable(idCiclo);
                aux[0] = dataTableActual;
            } else {
                const dataTableActual = await getDatosTableNextStep(idCiclo, pasoNext - 1, registrosSeleccionados);
                aux[pasoNext - 1] = dataTableActual;
            }

            //  Construir auxRegistrosSeleccionados con idest del paso actual actualizado
            let auxRegistrosSeleccionados = [...registrosSeleccionados];
            if(aux[pasoNext - 1]){
                const docActualizado = aux[pasoNext - 1].find(r => String(r.id) === String(idDocPasoActual));
                if(docActualizado){
                    auxRegistrosSeleccionados[pasoNext - 1] = {
                        ...auxRegistrosSeleccionados[pasoNext - 1],
                        [`idest_${pasoNext}`]: docActualizado.idest,
                        [`est_${pasoNext}`]: docActualizado.esttab
                    };
                }
            }

            // Añadir/actualizar registro del siguiente paso con su idest
            const clave = "runciccfgTab_" + siguientePaso;
            const valor = `#row-${respuesta.data.iddoc}`;
            const idxReg = auxRegistrosSeleccionados.findIndex(
                reg => Object.keys(reg)[0] === clave
            );
            if(idxReg !== -1){
                auxRegistrosSeleccionados[idxReg] = {
                    ...auxRegistrosSeleccionados[idxReg],
                    [clave]: valor,
                    [`idest_${siguientePaso}`]: respuesta.data.idest,
                    [`est_${siguientePaso}`]: respuesta.data.esttab
                };
            } else {
                auxRegistrosSeleccionados.push({ 
                    [clave]: valor,
                    [`idest_${siguientePaso}`]: respuesta.data.idest,
                    [`est_${siguientePaso}`]: respuesta.data.esttab
                });
            }

            //  Cargar tabla del siguiente paso usando idDocPasoActual como referencia
            const dataNext = new FormData();
            dataNext.append("validacion", apiKey());
            dataNext.append("idciclo", idCiclo);
            dataNext.append("steps", JSON.stringify([pasoNext]));
            dataNext.append("idsclonar", JSON.stringify([idDocPasoActual]));
            const respuestaSiguiente = await axiosPost(
                getApiUrl(window.location.origin) + confPantalla.runciccfg.padre.getdatostablenextstep,
                dataNext,
                source.token
            );

        
            if(typeof respuestaSiguiente.data !== "string" && respuestaSiguiente.data[0]){
                aux[siguienteIndex] = respuestaSiguiente.data[0];  
            }

            if(respuestaSiguiente.data[0] && respuestaSiguiente.data[0].length > 0){
                const nuevoDoc = respuestaSiguiente.data[0].find(
                    r => String(r.id) === String(respuesta.data.iddoc)
                );
                const idestNuevoDoc = nuevoDoc ? nuevoDoc.idest : null;
                
                const idxReg = auxRegistrosSeleccionados.findIndex(
                    reg => Object.keys(reg)[0] === clave
                );
                if(idxReg !== -1 && idestNuevoDoc !== null){
                    auxRegistrosSeleccionados[idxReg][`idest_${siguientePaso}`] = idestNuevoDoc;
                }
            }

        
            // Dispatch — activeStep = índice base 0 del step al que vamos
            updateStepperState(auxRegistrosSeleccionados, aux, siguienteIndex);

            if(cerrarModal){
                saveShowModalNextStep(false);
            }else{
                if(filtrarLineas){
                    const dataTableLineasModal = await getTablaModalLineas(
                        idCiclo, stepBtnNext, auxRegistrosSeleccionados, true
                    );
                    saveTablaModalNextStep(dataTableLineasModal);
                }else{
                    const dataTableLineasModalDiviApl = await getTablaModalLineas(
                        idCiclo, stepBtnNext, auxRegistrosSeleccionados, false
                    );
                    saveTablaModalNextStep(dataTableLineasModalDiviApl);
                }
            }
 
            saveLoadingCiclo(false);
            saveForceBtnNext(forceBtnNext => forceBtnNext + 1);
            saveShowModalNextStep(false);

            if(showModal == false){
                if(idCiclo && idCiclo !== ""){
                    try {                       
                        const dataAge = new FormData();
                        dataAge.append("validacion", apiKey());
                        dataAge.append("idCic", idCiclo);
                        dataAge.append("step", siguientePaso);
                        const resAge = await axiosPost(
                            getApiUrl(window.location.origin) + '/agentes/getResponsibleByCicId', 
                            dataAge, 
                            source.token
                        );
                        if(resAge.data.success && resAge.data.data && resAge.data.data.length > 0){
                            saveValResponsable(resAge.data.data[0].id);
                        }
                    } catch(error){
                        console.error('Error obteniendo responsable:', error);
                    }
                }
                saveShowModalResponsable(true);
            }
        }
    }
    const guardadoProvisional = async (e) =>{

        saveLoadingCiclo(true);

        const data = new FormData();      
        data.append("validacion", apiKey());        
        data.append("cantidades", JSON.stringify(cantidadEdi));
        data.append("ubicaciones", JSON.stringify(ubicacionesEdi));
        data.append("revisado", JSON.stringify(revisadoEdi));
        
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+"/runciccfg/guardadoProvisional", data, source.token);        

        if( typeof respuesta.data == "string"){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true}); 
            return;
        }else{
            alertService.success(`<i class="fal fa-times-octagon mr-1"></i>${confPantalla.runciccfg.padre.guardadoprovisional.title}`, {autoClose: true});            
        }  

        saveLoadingCiclo(false);
        saveShowModalNextStep(false);
    }

   const updateResponsable = async () => {       
        saveLoadingUpdateResponsable(true);        

        const data = new FormData();      
        data.append("validacion", apiKey());
        data.append("iddoc", idDocUpdateResponsable);
        data.append("idage2", valResponsable);
        data.append("step", stepBtnNext);
        data.append("accion", varAccion);        
        const respuesta = await axiosPost(
            getApiUrl(window.location.origin) + confPantalla.runciccfg.padre.modalresponsable.updateresponsable, 
            data, 
            source.token
        );

        if(typeof respuesta.data == "string"){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true}); 
            saveLoadingUpdateResponsable(false);
            saveShowModalResponsable(false);
            return;
        }

        
        // stepBtnNext = paso actual (base 1) desde el que venimos
        // siguientePaso = paso al que vamos (base 1)
        const siguientePaso = stepBtnNext + 1;
        const siguienteIndex = siguientePaso - 1; // índice base 0

        const aux = [...datosTablas];

        if(stepBtnNext === 1){
            const dataTableActual = await getDatosTable(idCiclo); 
            aux[0] = dataTableActual;
        } else {
            const dataTableActual = await getDatosTableNextStep(idCiclo, stepBtnNext - 1, registrosSeleccionados);
            aux[stepBtnNext - 1] = dataTableActual;
        }

        let auxRegistrosSeleccionados = [...registrosSeleccionados];
        const idDocPasoActual = registrosSeleccionados
            .filter(reg => Object.keys(reg)[0] == "runciccfgTab_" + stepBtnNext)[0]
            ["runciccfgTab_" + stepBtnNext].split("-")[1];

        if(aux[stepBtnNext - 1]){
            const docActualizado = aux[stepBtnNext - 1].find(r => String(r.id) === String(idDocPasoActual));
            if(docActualizado){
                auxRegistrosSeleccionados[stepBtnNext - 1] = {
                    ...auxRegistrosSeleccionados[stepBtnNext - 1],
                    [`idest_${stepBtnNext}`]: docActualizado.idest,
                    [`est_${stepBtnNext}`]: docActualizado.esttab
                };
            }
        }

        const clave = "runciccfgTab_" + siguientePaso;
        const valor = `#row-${respuesta.data.iddoc}`;
        const idxReg = auxRegistrosSeleccionados.findIndex(
            reg => Object.keys(reg)[0] === clave
        );
        if(idxReg !== -1){
            auxRegistrosSeleccionados[idxReg] = {
                ...auxRegistrosSeleccionados[idxReg],
                [clave]: valor,
                [`idest_${siguientePaso}`]: respuesta.data.idest,
                [`est_${siguientePaso}`]: respuesta.data.esttab
            };
        } else {
            auxRegistrosSeleccionados.push({ 
                [clave]: valor,
                [`idest_${siguientePaso}`]: respuesta.data.idest,
                [`est_${siguientePaso}`]: respuesta.data.esttab
            });
        }

        const dataNext = new FormData();
        dataNext.append("validacion", apiKey());
        dataNext.append("idciclo", idCiclo);
        dataNext.append("steps", JSON.stringify([stepBtnNext]));
        dataNext.append("idsclonar", JSON.stringify([idDocPasoActual]));
        const respuestaSiguiente = await axiosPost(
            getApiUrl(window.location.origin) + confPantalla.runciccfg.padre.getdatostablenextstep,
            dataNext,
            source.token
        );
        if(typeof respuestaSiguiente.data !== "string" && respuestaSiguiente.data[0]){
            aux[siguienteIndex] = respuestaSiguiente.data[0];

            const nuevoDoc = respuestaSiguiente.data[0].find(
                r => String(r.id) === String(respuesta.data.iddoc)
            );
            if(nuevoDoc){
                const idxUpd = auxRegistrosSeleccionados.findIndex(
                    reg => Object.keys(reg)[0] === clave
                );
                if(idxUpd !== -1){
                    auxRegistrosSeleccionados[idxUpd][`idest_${siguientePaso}`] = nuevoDoc.idest;
                    auxRegistrosSeleccionados[idxUpd][`est_${siguientePaso}`] = nuevoDoc.esttab;
                }
            }
        }

        updateStepperState(auxRegistrosSeleccionados, aux, siguienteIndex);

        saveLoadingUpdateResponsable(false);
        saveShowModalResponsable(false);
    }

    const filterCantidadEdi = (cantidadEdi, auxSelectedLines) => {
        let data = [];
        data = cantidadEdi.filter((reg, index) => {            
            if(auxSelectedLines.includes(reg.idLin)){
                reg.cant == ''? reg.cant = 0: reg.cant = reg.cant;
                return reg;
            }
        })
        return data;
    }

    const filterUbicacionesEdi = (ubicacionesEdi, auxSelectedLines) => {        
        let data = [];
        data = ubicacionesEdi.filter((reg, index) => {            
            if(auxSelectedLines.includes(reg.idLin)){
                reg.idubi == ''? reg.idubi = 0: reg.idubi = reg.idubi;
                return reg;
            }
        })
        return data;
    }

    const getDatosTableNextStep = async (idCiclo, step, regSeleccionados, steps=null) => { 

        let datosTabla = [];
        saveLoadingCiclo(true);        

        let appendStep = [];
        let idsClonar = [];
        let idClonar;        
                    
        if(steps != null){
            const regStep1 = regSeleccionados.filter((reg) => Object.keys(reg)[0] == "runciccfgTab_1");
            idClonar = regStep1.length > 0 ? regStep1[0]["runciccfgTab_1"].split("-")[1] : null;            
            appendStep = steps;
        }else{
            const regStep = regSeleccionados.filter((reg) => Object.keys(reg)[0] == "runciccfgTab_"+step);
            idClonar = regStep.length > 0 ? regStep[0]["runciccfgTab_"+step].split("-")[1] : null;            
            appendStep.push(step);            
        }

        if (!idClonar) {
            saveLoadingCiclo(false);
            return [];
        }

        for(let i = 0; i < appendStep.length; i++){            
            idsClonar.push(idClonar);
            idClonar = null;
        }

        if(appendStep.length > 0){
            const data = new FormData();      
            data.append("validacion", apiKey());
            data.append("idciclo", idCiclo);
            data.append("steps", JSON.stringify(appendStep));
            data.append("idsclonar", JSON.stringify(idsClonar));        
            const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.runciccfg.padre.getdatostablenextstep, data, source.token);
            if( typeof respuesta.data == "string"){
                alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true}); 
            }else{
                datosTabla = respuesta.data;
            }
        }
       
        saveLoadingCiclo(false);

        if(step == null){
            return datosTabla;
        }else{
            return datosTabla[0];
        }         
    }

    const getTablaModalLineas = async (idCiclo, step, regSeleccionados, filterLines=false) => { 

        let datosTabla = [];
        saveLoadingCiclo(true);

        const regStep = regSeleccionados.filter((reg) => Object.keys(reg)[0] == "runciccfgTab_"+step);
        const idDoc = regStep.length > 0 ? regStep[0]["runciccfgTab_"+step].split("-")[1] : null;

        if (!idDoc) {
            saveLoadingCiclo(false);
            return [];
        }

        const data = new FormData();      
        data.append("validacion", apiKey());
        data.append("idciclo", idCiclo);
        data.append("step", step);
        data.append("iddoc", idDoc);
        data.append("filterlines", filterLines);
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.runciccfg.padre.gettablalineasmodal, data, source.token);

        if( typeof respuesta.data == "string"){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true}); 
        }else{
            datosTabla = respuesta.data;
        }
       
        saveLoadingCiclo(false);

        return datosTabla;
    }

    const verLineas = async (step, idTabla) => {        
        savePasoTablaVerLineas(step);
        saveTablaLineas([]);
        await getTablaLineas(step, idTabla);        
        saveShowModalLineas(true);
    }

    const getTablaLineas = async (step, idTabla) => {         
        saveLoadingTablaLineas(true); 

        const idDoc = registrosSeleccionados.filter((reg) => Object.keys(reg)[0] == "runciccfgTab_"+(step+1))[0]["runciccfgTab_"+(step+1)].split("-")[1];

        const data = new FormData();      
        data.append("validacion", apiKey());        
        data.append("iddoc", idDoc);        
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.runciccfg.padre.modallineas.datatablelineas.getdata, data, source.token);

        if( typeof respuesta.data == "string"){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true}); 
        }else{
            saveTablaLineas(respuesta.data);
        }  
       
        saveLoadingTablaLineas(false);
    }

    const verInfoOperacion = async (step, idTabla) => {
        saveDatosTablaInfoOperacion([]);
        await getTablaInfoOperacion(step, idTabla);        
        saveShowModalInfoOperacion(true);
    }

    const getTablaInfoOperacion = async (step, idTabla) => {         
        saveLoadingTablaInfoOperacion(true); 

        const idDoc = registrosSeleccionados.filter((reg) => Object.keys(reg)[0] == "runciccfgTab_"+(step+1))[0]["runciccfgTab_"+(step+1)].split("-")[1];

        const data = new FormData();      
        data.append("validacion", apiKey());        
        data.append("iddoc", idDoc);
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.runciccfg.padre.modalinfooperacion.datatableinfooperacion.getdata, data, source.token);

        if( typeof respuesta.data == "string"){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true}); 
        }else{
            saveDatosTablaInfoOperacion(respuesta.data);
        }  
       
        saveLoadingTablaInfoOperacion(false);
    }

    const disabledBtnNext = (step) =>{       
        let deshabilitar = true;      
        
        if(Array.isArray(registrosSeleccionados) && registrosSeleccionados.length > 0){
            const guardar = registrosSeleccionados.filter((reg) => Object.keys(reg)[0] == "runciccfgTab_"+step)                
            guardar.length > 0 ? deshabilitar =  false: deshabilitar = true;
        }

        return deshabilitar;
    }


    const handleSelectRegTable = async (e, idTabla) => {
        let target = e.target;
        while (target && !target.id.includes("#row-")) {
            target = target.parentElement;
        }
        if (!target) return;

        saveLoadingCiclo(true);

        const idRow = target.id;
        const selectedRows = $('#' + idTabla).DataTable().rows({ selected: true }).data();
        const isSelected = selectedRows.length > 0;

        if (isSelected) {
            // Selección — recargar todo desde el doc seleccionado
            await autoIniciarFull(idRow.split("-")[1], null, false);
        } else {
            // Deselección — solo limpiar selecciones, mantener datos de tablas
            stepperDispatch({
                type: 'HANDLE_ROW_SELECT',
                payload: { idTabla, idRow, isSelected }
            });
        }

        saveLoadingCiclo(false);
    };


    const clearNextTables = (auxDatosTablas, idTabla) => {
        let data=[];
        let encontrado = false;         
        for(let i=0; i<numSteps.length; i++){
            if (("runciccfgTab_"+(i+1)) == idTabla) {
                encontrado = true;
                data.push(auxDatosTablas[i])
            }else if(encontrado){
                let oTable = $(".runciccfgTab_"+(i+1)).DataTable();
                oTable.clear();
                oTable.draw();
            }else{
                data.push(auxDatosTablas[i])
            }
        }
        
        return data;
    }

    const getColumnsDinamyc = () => {        
        let columns = [];
        columns.push({ title: "Articulo", data: "unidad" });
        for(let i=0; i<titleTabs.length; i++){
            const title = titleTabs[i].tipo.split('-')[0];
            columns.push({ title: title, data: `s${i+1}` });
        }        
        return columns;
    }


    const loadOptionsCbo = async (fuente, opcion, options, saveOptions, backUp=false) =>{
        const data = new FormData();
        data.append("validacion", apiKey());                        
        
        const idCookie = await encryptData(cookies.get('id'), appCryptCom);
        data.append('ua', idCookie);
        const nivelCookie = await encryptData(cookies.get('nivel'), appCryptCom);
        data.append('na', nivelCookie);
                    
        // Encriptamos el tag sql. 
        opcion = await encryptData(opcion, appCryptCom);
        data.append(fuente, opcion);                

        if( options == null ){
            let url = null;
            if( fuente == "filter" ){
                url = getApiUrl(window.location.origin)+'/filters/getFilter';
            }else{
                url = getApiUrl(window.location.origin)+'/app/getDataCbo';
            }
            const respuesta = await axios.post(url, data);
            saveOptions(respuesta.data);            
            if(backUp){
                backUpOptionsUbi = respuesta.data;
            }
                
        }

        saveLoadedSelect(true);
    }

    const handleInput = (e, save) => {        
        save(e.target.value)
    }

    const handleCheck = (e) => {        
        if( e.target.checked ){              
            saveValModalIncludeCero(true);
        }else{
            saveValModalIncludeCero(false);
        }
    }

    
    return(
        <div className="App wrapper">    
        <Alert fondo={true} />
        {
            confPantalla !== undefined
            ?
                <Fragment>
                    <Menusup 
                        props = { props }
                    />
                    <Sidebar 
                        props = { props }
                    />
                </Fragment>
            :
            null
        } 
        <div className="content-wrapper">
            <div className="content-header">
            </div>
            <section className="content">
                {
                    !tieneNivel 
                    ?
                        <PermissionRefused
                            traduction={confPantalla.config.trad.components.permissionrefused} 
                        />
                    :
                    <Fragment>
                    {
                        loadedConf === true && confPantalla !== undefined
                        ?
                            <Section
                                // tituloenhtml={true}  
                                titulo={ confPantalla.runciccfg.section.titulo } 
                                icono={ confPantalla.runciccfg.section.icono } 
                                col={ confPantalla.runciccfg.section.col } 
                                idPrin={idCiclo} 
                                wiki={ confPantalla.runciccfg.section.wiki } 
                                recurrencia={codCic}
                                // idPrin={lineaSelect} 
                                // informes={ confPantalla.runciccfg.padre.informes } 
                                // disabledInformes={!loadingCiclo || forceBtnNext ? disabledBtnNext(index+1) : true}
                            > 
                                <MiSelect  
                                    estadoForm=  { confPantalla.runciccfg.padre.estadoform }
                                    val=         { idCiclo  }   
                                    // loading=     { loadingCiclo ? true : false }
                                    loading=     { false }
                                    id=          { confPantalla.runciccfg.padre.idciccfg.id }    
                                    name=        { confPantalla.runciccfg.padre.idciccfg.name }   
                                    label=       { confPantalla.runciccfg.padre.idciccfg.label }    
                                    placeholder= { confPantalla.runciccfg.padre.idciccfg.placeholder }
                                    col=         { confPantalla.runciccfg.padre.idciccfg.col } 
                                    isClearable= { confPantalla.runciccfg.padre.idciccfg.isclearable }
                                    isSearchable={ confPantalla.runciccfg.padre.idciccfg.issearchable }
                                    dataType=    { confPantalla.runciccfg.padre.idciccfg.datatype }
                                    data=        { confPantalla.runciccfg.padre.idciccfg.data }
                                    required=    { confPantalla.runciccfg.padre.idciccfg.required } 
                                    disabled=  { confPantalla.runciccfg.padre.idciccfg.disabled }
                                    readOnly =   { confPantalla.runciccfg.padre.idciccfg.readonly }
                                    disablethisid={confPantalla.runciccfg.padre.idciccfg.disablethisid}
                                    disableids={confPantalla.runciccfg.padre.idciccfg.disableids}
                                    formulario= { {id:0} }   
                                    change= { handleSelectCiclo }
                                    labelExtra={
                                        <Informes
                                            select={confPantalla.runciccfg.padre.informes.select}
                                            formulario={{ id: idCiclo }}
                                            loadReg={loadReg ? true : false}
                                            estadoForm={false}
                                            traduction={confPantalla.config.trad.components}
                                            disabled={!idCiclo || idCiclo === ""}
                                        />
                                    }
                                />
                                {  loadingCiclo ? 
                                        <SpinnerFloat />
                                    :
                                     null
                                }
                                {
                                    idCiclo != ""
                                    ?
                                    
                                        <Button 
                                            clases={ "btn-block mb-3" }
                                            color={ "success" }  
                                            type="button" 
                                            icono={ "fal fa-plus" }   
                                            id={"btnAdd"}     
                                            texto={ " "+confPantalla.runciccfg.padre.btnadd.title }   
                                            accion={ () => showModalFn() } 
                                            disabled={ loadingCiclo ? true : false }
                                        /> 
                                    :
                                        null
                                }
                                {
                                    idCiclo != ""
                                    ?
                                    <div className="ruciccfg-tabs">
                                        <style>{keyframesStyle}</style>
                                        <Stepper activeStep={activeStep} alternativeLabel className="mb-4" connector={<QontoConnector />} 
                                            sx={{ 
                                                '& .MuiStepConnector-line': {
                                                    transition: 'all 0.3s ease',
                                                    borderTopWidth: 2,
                                                },
                                                '& .MuiStepConnector-root.Mui-active .MuiStepConnector-line': {
                                                    borderColor: stepColors[activeStep] || '#007bff',
                                                    borderTopWidth: 4,
                                                },
                                                '& .MuiStepConnector-root.Mui-completed .MuiStepConnector-line': {
                                                    borderColor: '#4caf50',
                                                },                                               
                                            }}
                                        >
                                            {numSteps.map((linea, index) => {
                                                const isStepDisabled = !registrosSeleccionados[index]?.[ `runciccfgTab_${index + 1}`];
                                                const stepColor = stepColors[index] || '#007bff';

                                                return (
                                                    <Step
                                                        key={index}
                                                        onClick={() => !isStepDisabled && handleStepClick(index)}
                                                        style={{ 
                                                            cursor: isStepDisabled ? 'not-allowed' : 'pointer', 
                                                            opacity: isStepDisabled ? 0.5 : 1 
                                                        }}
                                                        disabled={isStepDisabled}
                                                    >
                                                        <StepLabel
                                                            StepIconComponent={() => (
                                                                <ColoredStepIcon color={stepColor} index={index}  isActive={index === activeStep && !!registrosSeleccionados[index]?.[`runciccfgTab_${index + 1}`]}  />
                                                            )}
                                                        >
                                                            {renderedTitleTabs[index] ? renderedTitleTabs[index] : (index + 1)}
                                                        </StepLabel>
                                                    </Step>
                                                );
                                            })}
                                        </Stepper>
                                        
                                        {numSteps.map((linea, index) => {

                                            const isActive = index === activeStep;                                     
                                            lineaSelect = registrosSeleccionados[index]?.[`runciccfgTab_${index+1}`]
                                                            ? registrosSeleccionados[index][`runciccfgTab_${index+1}`].split("-")[1]
                                                            : null;                                         
                                            const idDoc = lineaSelect || 0;
                                                  
                                            const isStepEnCurso = (() => {
                                                const regEntry = registrosSeleccionados[index];
                                                if (!regEntry) return false;
                                                
                                                // Primero intentar con idest guardado directamente
                                                const idest = regEntry[`idest_${index + 1}`];                                              
                                                if (idest !== undefined) return parseInt(idest) === 8;
                                                
                                                // Fallback: buscar en tabla
                                                const rowValue = regEntry[`runciccfgTab_${index + 1}`];
                                                if (!rowValue) return false;
                                                const stepLineaSelect = rowValue.split("-")[1];
                                                if (!stepLineaSelect) return false;
                                                
                                                const tabla = datosTablas[index];
                                                if (!tabla || !tabla.length) return false;
                                                
                                                const found = tabla.find(reg => String(reg.id) === String(stepLineaSelect));
                                                return found ? parseInt(found.idest) === 8 : false;
                                            })();
                                            
                                            const defaultAgeNextStep = datosTablas[index]
                                                ? (() => {
                                                    const found = datosTablas[index].find((row) => row.id === idDoc);
                                                    return found && found.agedef != null && found.idage2 != ''
                                                        ? found.agedef : cicDefAge;
                                                })() : cicDefAge;

                                            const idEstDoc = datosTablas[index]
                                                ? (() => {
                                                    const found = datosTablas[index].find((row) => row.id === idDoc);
                                                    return found ? found.idest : 0;
                                                })() : 0;

                                            const infoDocSelectThisTable = datosTablas[index]
                                                ? datosTablas[index].filter((reg) => reg.id == lineaSelect)
                                                : null;

                                            const isDocRechazado = (() => {
                                                const found = datosTablas[index]
                                                    ? datosTablas[index].find((row) => row.id == lineaSelect)
                                                    : null;
                                                if (!found) return false;
                                                if (found.esttab) return String(found.esttab).toUpperCase() === 'RECHAZADO';
                                                return parseInt(found.idest) === 7;
                                            })();

                                            const activarBtnLanzarSolicitud = !!(
                                                infoDocSelectThisTable?.[0] &&
                                                infoDocSelectThisTable[0].idtip == infoDocSelectThisTable[0].tipdocreq
                                            );
                                            
                                            const btnNext = <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%"}}>
                                                                    <div>
                                                                        {
                                                                            activarBtnLanzarSolicitud == true && idDoc != 0 && idEstDoc == 8 && !isDocRechazado
                                                                            ?
                                                                                <NavLink 
                                                                                    to={"/request/"+idDoc} 
                                                                                    className="mb-3 btn btn-flat mr-1 btn-success"
                                                                                >
                                                                                    <i className="fal fa-arrow-to-right mr-1" style={{marginRight:5}} />
                                                                                    { confPantalla.runciccfg.padre.btnnext.title  }
                                                                                </NavLink>
                                                                            :
                                                                            numSteps.length == (index+1)
                                                                            ?
                                                                          
                                                                            <Button 
                                                                                index={"btn-"+(index+1)} 
                                                                                clases={ " mb-3" } 
                                                                                color={ "success" }  
                                                                                type="button" 
                                                                                icono={ "fal fa-arrow-to-right mr-1" }   
                                                                                id={"btnnext-"+(index+1)}     
                                                                                texto={ confPantalla.runciccfg.padre.btnnext.title }   
                                                                                accion={ () => nextStep(index+1, defaultAgeNextStep) } 
                                                                                disabled={isDocRechazado || (!loadingCiclo && index !== activeStep && !registrosSeleccionados[index])}                                                                             
                                                                                // disabled={ !isActive }                                                                             
                                                                            />
                                                                            
                                                                            :
                                                                            <Button
                                                                                index={"btn-"+(index+1)}
                                                                                clases={ " mb-3" }
                                                                                color={ "success" }  
                                                                                type="button" 
                                                                                icono={ "fal fa-arrow-to-right mr-1" }   
                                                                                id={"btnnext-"+(index+1)}     
                                                                                texto={ confPantalla.runciccfg.padre.btnnext.title }   
                                                                                accion={ () => nextStep(index+1, defaultAgeNextStep) } 
                                                                                disabled={isDocRechazado || (!loadingCiclo && index !== activeStep && !registrosSeleccionados[index])}                                                                             
                                                                                // disabled={ !isActive}
                                                                               />
                                                                        }
                                                                        {
                                                                            idDoc > 0 && activarBtnLanzarSolicitud && !isDocRechazado
                                                                            ?
                                                                                <NavLink 
                                                                                    to={"/request/"+idDoc} 
                                                                                    className="mb-3 btn btn-flat mr-1 btn-primary"
                                                                                >
                                                                                    <i className="fal fa-file-invoice" style={{marginRight:5}} />
                                                                                    { " "+confPantalla.runciccfg.padre.btnsolicitud.title }
                                                                                </NavLink>
                                                                            :
                                                                                <Button
                                                                                    index={"btn-"+(index+1)}
                                                                                    clases={ " mb-3" }
                                                                                    color={ "primary" }  
                                                                                    type="button" 
                                                                                    icono={ "fal fa-file-invoice" }   
                                                                                    id={"btnreq-"+(index+1)}     
                                                                                    texto={ " "+confPantalla.runciccfg.padre.btnsolicitud.title }   
                                                                                    accion={ null }
                                                                                    disabled={ true }
                                                                                />                                                                          
                                                                        }                                                                     
                                                                    </div>
                                                                    <div>
                                                                        <Button
                                                                            index={"btn-"+(index+1)}
                                                                            clases={ " mb-3" }
                                                                            color={ "warning" }  
                                                                            type="button" 
                                                                            icono={ "fal fa-info-circle" }   
                                                                            id={"btninfo-"+(index+1)}     
                                                                            texto={ " "+confPantalla.runciccfg.padre.btninfolineas.title }
                                                                            accion={ () => verLineas(index, "infoLineasTab_"+(index+1)) }
                                                                            disabled={ !loadingCiclo || forceBtnNext ? disabledBtnNext(index+1) : true }
                                                                        />


                                                                        {
                                                                            
                                                                           idDoc > 0 && isStepEnCurso
                                                                            ?
                                                                                <NavLink 
                                                                                    to={"/edirap/"+idDoc} 
                                                                                    className="mb-3 btn btn-flat mr-1 btn-primary" 
                                                                                    onClick={() => sessionStorage.setItem('edirap_remove_eye', true)}
                                                                                > 
                                                                                    <i className="fal fa-eye" style={{marginRight:5}} /> 
                                                                                    { " "+confPantalla.runciccfg.padre.btnver.title } 
                                                                                </NavLink> 
                                                                            :
                                                                                <Button 
                                                                                    index={"btn-"+(index+1)} 
                                                                                    clases={ " mb-3" } 
                                                                                    color={ "primary" }  
                                                                                    type="button" 
                                                                                    icono={ "fal fa-eye" }   
                                                                                    id={"btnver-"+(index+1)}     
                                                                                    texto={ " "+confPantalla.runciccfg.padre.btnver.title }   
                                                                                    accion={ null } 
                                                                                    disabled={ true } 
                                                                                />                                                                
                                                                        }
                                                                    </div>
                                                                </div>
                                                                 const tabla = (
                                                                    <div 
                                                                        id={"divTab_"+(index+1)} 
                                                                        onClick={(e) => handleSelectRegTable(e, "runciccfgTab_"+(index+1))}
                                                                    >
                                                                        <MiDataTableRunciccfg 
                                                                            estadoForm=""
                                                                            formulario={{id:0}}
                                                                            id={"runciccfgTab_"+(index+1)}
                                                                            columnas={confPantalla.runciccfg.padre.datatable.columns}
                                                                            data={datosTablas[index]}  
                                                                            buttons={confPantalla.runciccfg.padre.datatable.buttons}
                                                                            ordering={confPantalla.runciccfg.padre.datatable.ordering}
                                                                            order={confPantalla.runciccfg.padre.datatable.order}
                                                                            searching={confPantalla.runciccfg.padre.datatable.searching}
                                                                            paging={confPantalla.runciccfg.padre.datatable.paging}
                                                                            select={confPantalla.runciccfg.padre.datatable.select}
                                                                            pagelength={confPantalla.runciccfg.padre.datatable.pagelength}
                                                                            columnactions={confPantalla.runciccfg.padre.datatable.columnactions.title}
                                                                            linkColumns={confPantalla.runciccfg.padre.datatable.linkColumns}
                                                                            traduction={confPantalla.config.trad.components.datatable}
                                                                            registrosSeleccionados={registrosSeleccionados}
                                                                            datosTablas={datosTablas}
                                                                            selectId={{id: lineaSelect}}
                                                                        />
                                                                    </div>
                                                                );                                              
                                                      return (
                                                            <div 
                                                                key={index} 
                                                                style={{ 
                                                                    display: isActive ? 'block' : 'none'
                                                                }}
                                                            >
                                                                {btnNext}
                                                                {tabla}
                                                            </div>
                                                        );
                                                    })}
                                    </div>
                                    :
                                        null
                                }
                                                                                                            
                            </Section>
                        :
                            <LoadingPage />
                        }
                    </Fragment>
                }
                
            </section>
        </div>
        <Footer /> 
        {
            showModal 
            ?
                <Modal
                    show={showModal}
                    onHide={ () => saveShowModal(false)}                            
                    aria-labelledby="example-custom-modal-styling-title"
                    centered={true}                    
                    dialogClassName="modal-90w" 
                    >
                    <Modal.Header closeButton>                        
                    </Modal.Header>                            
                    <Modal.Body>
                        <FormRow>
                            <MiSelect  
                                estadoForm=  { "" }
                                val=         { valModalCentro }   
                                loading=     { false }
                                id=          { confPantalla.runciccfg.padre.modaliniciar.idcen.id }    
                                name=        { confPantalla.runciccfg.padre.modaliniciar.idcen.name }   
                                label=       { confPantalla.runciccfg.padre.modaliniciar.idcen.label }    
                                placeholder= { confPantalla.runciccfg.padre.modaliniciar.idcen.placeholder }
                                col=         { confPantalla.runciccfg.padre.modaliniciar.idcen.col } 
                                isClearable= { confPantalla.runciccfg.padre.modaliniciar.idcen.isclearable }
                                isSearchable={ confPantalla.runciccfg.padre.modaliniciar.idcen.issearchable }
                                dataType=    { confPantalla.runciccfg.padre.modaliniciar.idcen.datatype }
                                data=        { confPantalla.runciccfg.padre.modaliniciar.idcen.data }
                                required=    { confPantalla.runciccfg.padre.modaliniciar.idcen.required } 
                                disabled=  { confPantalla.runciccfg.padre.modaliniciar.idcen.disabled }
                                readOnly =   { confPantalla.runciccfg.padre.modaliniciar.idcen.readonly }
                                disablethisid={confPantalla.runciccfg.padre.modaliniciar.idcen.disablethisid}
                                disableids={ confPantalla.runciccfg.padre.modaliniciar.idcen.disableids}
                                formulario= { {id:0} }   
                                change= { (selectedItem, nameOfComponent) => handleSelect(selectedItem, nameOfComponent, saveValModalCentro) }
                            />
                            <MiSelect  
                                estadoForm=  { "" }
                                val=         { valModalResponsable }   
                                loading=     { false }
                                id=          { confPantalla.runciccfg.padre.modaliniciar.idage2.id }    
                                name=        { confPantalla.runciccfg.padre.modaliniciar.idage2.name }   
                                label=       { confPantalla.runciccfg.padre.modaliniciar.idage2.label }    
                                placeholder= { confPantalla.runciccfg.padre.modaliniciar.idage2.placeholder }
                                col=         { confPantalla.runciccfg.padre.modaliniciar.idage2.col } 
                                isClearable= { confPantalla.runciccfg.padre.modaliniciar.idage2.isclearable }
                                isSearchable={ confPantalla.runciccfg.padre.modaliniciar.idage2.issearchable }
                                dataType=    { confPantalla.runciccfg.padre.modaliniciar.idage2.datatype }
                                data=        { confPantalla.runciccfg.padre.modaliniciar.idage2.data }
                                required=    { confPantalla.runciccfg.padre.modaliniciar.idage2.required } 
                                disabled=  { confPantalla.runciccfg.padre.modaliniciar.idage2.disabled }
                                readOnly =   { confPantalla.runciccfg.padre.modaliniciar.idage2.readonly }
                                disablethisid={confPantalla.runciccfg.padre.modaliniciar.idage2.disablethisid}
                                disableids={ confPantalla.runciccfg.padre.modaliniciar.idage2.disableids}
                                formulario= { {id:0} }   
                                change= { (selectedItem, nameOfComponent) => handleSelect(selectedItem, nameOfComponent, saveValModalResponsable) }
                            />
                        </FormRow>
                        <FormRow>
                            <MiSelect  
                                estadoForm=  { confPantalla.runciccfg.padre.modaliniciar.estadoform }
                                val=         { idNuevoCiclo  }   
                                loading=     { false }
                                id=          { confPantalla.runciccfg.padre.modaliniciar.documentos.id }    
                                name=        { confPantalla.runciccfg.padre.modaliniciar.documentos.name }   
                                label=       { confPantalla.runciccfg.padre.modaliniciar.documentos.label }    
                                placeholder= { confPantalla.runciccfg.padre.modaliniciar.documentos.placeholder }
                                col=         { confPantalla.runciccfg.padre.modaliniciar.documentos.col } 
                                isClearable= { confPantalla.runciccfg.padre.modaliniciar.documentos.isclearable }
                                isSearchable={ confPantalla.runciccfg.padre.modaliniciar.documentos.issearchable }
                                dataType=    { confPantalla.runciccfg.padre.modaliniciar.documentos.datatype }
                                data=        { confPantalla.runciccfg.padre.modaliniciar.documentos.data }
                                required=    { confPantalla.runciccfg.padre.modaliniciar.documentos.required } 
                                disabled=  { confPantalla.runciccfg.padre.modaliniciar.documentos.disabled }
                                readOnly =   { confPantalla.runciccfg.padre.modaliniciar.documentos.readonly }
                                disablethisid={confPantalla.runciccfg.padre.modaliniciar.documentos.disablethisid}
                                disableids={confPantalla.runciccfg.padre.modaliniciar.documentos.disableids}
                                formulario= { {id:0} }   
                                change= { (selectedItem, nameOfComponent) => handleSelect(selectedItem, nameOfComponent, saveIdNuevoCiclo, true) }
                            />
                        </FormRow>
                        <FormRow>
                            <FormInput                                                        
                                estadoForm= { confPantalla.runciccfg.padre.modaliniciar.estadoform }
                                value=      { valModalDescripcion }
                                loading=    { loadReg ? true : false }
                                id=         { confPantalla.runciccfg.padre.modaliniciar.nom1.id }   
                                type=       { confPantalla.runciccfg.padre.modaliniciar.nom1.type }  
                                name=       { confPantalla.runciccfg.padre.modaliniciar.nom1.name }   
                                label=      { confPantalla.runciccfg.padre.modaliniciar.nom1.label }                                                       
                                placeholder={ confPantalla.runciccfg.padre.modaliniciar.nom1.placeholder }    
                                col=        { confPantalla.runciccfg.padre.modaliniciar.nom1.col } 
                                required=   { confPantalla.runciccfg.padre.modaliniciar.nom1.required }
                                readonly=   { confPantalla.runciccfg.padre.modaliniciar.nom1.readonly }                                                
                                disabled=   { confPantalla.runciccfg.padre.modaliniciar.nom1.disabled }
                                change=     { e => handleInput(e, saveValModalDescripcion) }
                                onBlur=     {null} 
                            />
                        </FormRow>
                        <FormRow>
                            <CheckIos                                
                                val= { valModalIncludeCero }
                                name={null}
                                label={ confApp.supply.controles.modaliniciar.check.label }                                
                                id={'checkfirma'}
                                col={"12"}
                                change={ handleCheck }
                                required={ false }
                                disabled={ false }                               
                            />
                        </FormRow>
                        <p className="font-italic text-center">{ confPantalla.runciccfg.padre.modaliniciar.txtrequired.title }</p>
                        <p className="font-italic text-center">{confPantalla.runciccfg.padre.help.title}</p>
                        <button 
                            type="button" 
                            className="btn btn-flat btn-success btn-block " 
                            onClick={ (e) => nuevoCiclo() }
                            disabled={ idNuevoCiclo == 0 || valModalCentro == 0 || valModalResponsable == 0 || loadingNuevoCiclo == true ? true : false}
                            >
                            {confPantalla.runciccfg.padre.btncrear.title}
                        </button>
                        {  loadingNuevoCiclo ? 
                                <div className='mt-4' style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                    <Spinner animation="border" />
                                </div>
                            :
                            null
                        }
                    </Modal.Body>                            
                </Modal>
            :
                    null
        }
        {
            showModalNextStep 
            ?
                <Modal
                    show={showModalNextStep}
                    onHide={ () => saveShowModalNextStep(false)}                            
                    aria-labelledby="example-custom-modal-styling-title"
                    centered={true}                    
                    dialogClassName="modal-90w" 
                    >
                    <Modal.Header closeButton>
                        {getHeaderModalNextStep(infoModalNextStep)}
                    </Modal.Header>                          
                    <Modal.Body>
                        {  loadingModalNextStep ? 
                                <div className='mt-4' style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                    <Spinner animation="border" />
                                </div>
                            :
                            null
                        }                                             
                        {
                            datosTablas[stepBtnNext] && datosTablas[stepBtnNext].length > 0
                            ?
                                <MiDataTableRunciccfg
                                    formulario={{id:0}}
                                    id={"tableModalDocs"}
                                    columnas={confPantalla.runciccfg.padre.datatablemodaldocs.columns}
                                    data={datosTablas[stepBtnNext]}
                                    buttons={confPantalla.runciccfg.padre.datatablemodaldocs.buttons}
                                    ordering={confPantalla.runciccfg.padre.datatablemodaldocs.ordering}
                                    order={confPantalla.runciccfg.padre.datatablemodaldocs.order}
                                    searching={confPantalla.runciccfg.padre.datatablemodaldocs.searching}
                                    paging={confPantalla.runciccfg.padre.datatablemodaldocs.paging}
                                    select={confPantalla.runciccfg.padre.datatablemodaldocs.select}
                                    pagelength={confPantalla.runciccfg.padre.datatablemodaldocs.pagelength}                           
                                    columnactions={confPantalla.runciccfg.padre.datatablemodaldocs.title}
                                    traduction={confPantalla.config.trad.components.datatable}
                                    functionAfterSelect={getTxtHelp}                            
                                />
                            :
                                null
                        }                   
                        <FormRow clases='alert-warning mt-3 px-2 py-2 rounded-lg'>
                            <MiSelect  
                                estadoForm=  { "" }
                                val=         { valResponsable }   
                                loading=     { loadReg ? true : false }
                                id=          { confPantalla.runciccfg.padre.modalresponsable.idage2.id }    
                                name=        { confPantalla.runciccfg.padre.modalresponsable.idage2.name }   
                                label=       { confPantalla.runciccfg.padre.modalresponsable.idage2.label+"*" }    
                                placeholder= { confPantalla.runciccfg.padre.modalresponsable.idage2.placeholder }
                                col=         { 12 } 
                                isClearable= { confPantalla.runciccfg.padre.modalresponsable.idage2.isclearable }
                                isSearchable={ confPantalla.runciccfg.padre.modalresponsable.idage2.issearchable }
                                dataType=    { "url" }
                                data=        { "/agentes/getDirectionType" }
                                appendPost={ [{ key: "step", value: (activeStep +1) }] }
                                modifyOptions={ (options) => {
                                    const dataArray = options?.data || options;
                                    return Array.isArray(dataArray) ? dataArray.map(opt => ({ value: opt.id, label: opt.nomtab })) : [];
                                } }
                                required=    { confPantalla.runciccfg.padre.modalresponsable.idage2.required } 
                                disabled=    { confPantalla.runciccfg.padre.modalresponsable.idage2.disabled }
                                readOnly =   { confPantalla.runciccfg.padre.modalresponsable.idage2.readonly }
                                disablethisid={confPantalla.runciccfg.padre.modalresponsable.idage2.disablethisid}
                                disableids={ confPantalla.runciccfg.padre.modalresponsable.idage2.disableids}
                                formulario= { {id:0} }   
                                change= { (selectedItem, nameOfComponent) => handleSelectResponsable(selectedItem, nameOfComponent) }
                            />
                        </FormRow>
                        <p className='font-italic text-center'>{confPantalla.runciccfg.padre.helpmodal.txtrequired.title}</p>
                        <FormRow>
                            <InformesBtn
                                select =     { confPantalla.runciccfg.padre.informes.select }
                                formulario = { {id: idDocInformesModalNextStep} }
                                getRegistro = { confPantalla.runciccfg.padre.informes.getregistro }
                                loadReg =    { false }
                                estadoForm=  { "" } 
                                traduction=  { confPantalla.config.trad.components }
                                btnGenerar= { confPantalla.runciccfg.padre.informes.btngenerar.title }
                                logoContext={logo}
                                apiKeyContext={apiKey}
                                confAppContext={confApp}
                                appCryptComContext={appCryptCom}
                                buttonInLine={true}
                                disabled={ false }
                            />
                        </FormRow>
                        <MiDataTableRunciccfg
                            formulario={{id:0}}
                            id={"tableModalLineas"}
                            columnas={columnasModalLineas.length > 0 ? columnasModalLineas : confPantalla.runciccfg.padre.datatablemodallineas.datatable.columns}
                            data={tablaModalNextStep}
                            buttons={confPantalla.runciccfg.padre.datatablemodallineas.datatable.buttons}
                            ordering={confPantalla.runciccfg.padre.datatablemodallineas.datatable.ordering}
                            order={confPantalla.runciccfg.padre.datatablemodallineas.datatable.order}
                            searching={confPantalla.runciccfg.padre.datatablemodallineas.datatable.searching}
                            paging={confPantalla.runciccfg.padre.datatablemodallineas.datatable.paging}
                            select={confPantalla.runciccfg.padre.datatablemodallineas.datatable.select}
                            pagelength={confPantalla.runciccfg.padre.datatablemodallineas.datatable.pagelength}                           
                            columnactions={confPantalla.runciccfg.padre.datatablemodallineas.datatable.title}
                            traduction={confPantalla.config.trad.components.datatable}
                            cantidad={cantidadEdi}
                            saveCantidad={saveCantidadEdi}                            
                            step={stepBtnNext}
                            infoCiclo={infoCiclo[stepBtnNext-1]}
                            selectUbi={confPantalla.runciccfg.padre.datatablemodallineas.ubi}
                            optionSelectUbi={optionsUbi}
                            ubicaciones={ubicacionesEdi}
                            saveUbicaciones={saveUbicacionesEdi}
                            selectAllOnLoad={true}
                            revisado={revisadoEdi}
                            saveRevisado={saveRevisadoEdi}
                        />
                    {  loadingCiclo ? 
                            <div className='mt-4' style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                <Spinner animation="border" />
                            </div>
                        :
                        null
                    }
                    <button type="button" className="btn btn-flat btn-success mt-3 float-right " onClick={ (e) => okNextStepModal(e) } disabled={loadingCiclo || valResponsable < 1 ? true : false}>
                            {" "+confPantalla.runciccfg.padre.btnnext.title}
                    </button>
                    <button type="button" className="mr-2 btn btn-flat btn-primary mt-3 float-right " onClick={ (e) => guardadoProvisional(e) } disabled={loadingCiclo ? true : false}>
                            {" "+confPantalla.runciccfg.padre.btnguardar.title}
                    </button>
                    <button type="button" className="mr-2 btn btn-flat btn-danger mt-3 float-right " onClick={ () => saveShowModalNextStep(false) } disabled={loadingCiclo ? true : false}>
                            {" "+confPantalla.runciccfg.padre.btncancelar.title}
                    </button>
                    </Modal.Body>                            
                </Modal> 
            :
                    null
        }
        {
            showModalLineas
            ?
                <Modal
                    show={showModalLineas}
                    onHide={ () => saveShowModalLineas(false)}                            
                    aria-labelledby="example-custom-modal-styling-title"
                    centered={true}                    
                    dialogClassName="modal-90w" 
                    >
                    <Modal.Header closeButton>
                        <h4>{confPantalla.runciccfg.padre.modallineas.header.title}</h4>
                    </Modal.Header>                          
                    <Modal.Body>
                        {  loadingTablaLineas ? 
                                <div className='mt-4' style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                    <Spinner animation="border" />
                                </div>
                            :
                                null
                        }
                        <MiDataTableVerLineas 
                            estadoForm= { "" }
                            formulario={ {id:0} }
                            id={"tablaLineas"}
                            columnas={getColumnsDinamyc()}
                            data={tablaLineas}
                            buttons={confPantalla.runciccfg.padre.modallineas.datatablelineas.buttons}
                            ordering={confPantalla.runciccfg.padre.modallineas.datatablelineas.ordering}
                            order={confPantalla.runciccfg.padre.modallineas.datatablelineas.order}
                            searching={confPantalla.runciccfg.padre.modallineas.datatablelineas.searching}
                            paging={confPantalla.runciccfg.padre.modallineas.datatablelineas.paging}
                            select={confPantalla.runciccfg.padre.modallineas.datatablelineas.select}
                            pagelength={confPantalla.runciccfg.padre.modallineas.datatablelineas.pagelength}                            
                            columnactions={confPantalla.runciccfg.padre.modallineas.datatablelineas.columnactions.title}
                            linkColumns={confPantalla.runciccfg.padre.modallineas.datatablelineas.linkColumns}
                            traduction={confPantalla.config.trad.components.datatable}
                            pasoTablaVerLineas={pasoTablaVerLineas}                  
                        />
                                            
                    <button type="button" className="mr-2 btn btn-flat btn-danger mt-3 float-right " onClick={ () => saveShowModalLineas(false) }>
                            {confPantalla.runciccfg.padre.modallineas.btncerrar.title}
                    </button>
                    </Modal.Body>                            
                </Modal>
            :
                    null
        }
        {
            showModalResponsable
            ?
                <Modal
                    show={showModalResponsable}
                    onHide={ () => saveShowModalResponsable(false)}                            
                    aria-labelledby="example-custom-modal-styling-title"
                    centered={true}                    
                    dialogClassName="modal-90w "
                    backdrop="static" 
                    backdropClassName='runciccfgmodalrespbackdrop'                                       
                >                     
                    <Modal.Body>                    
                        <MiSelect  
                            estadoForm=  { "" }
                            val=         { valResponsable }   
                            loading=     { loadReg ? true : false }
                            id=          { confPantalla.runciccfg.padre.modalresponsable.idage2.id }    
                            name=        { confPantalla.runciccfg.padre.modalresponsable.idage2.name }   
                            label=       { confPantalla.runciccfg.padre.modalresponsable.idage2.label }    
                            placeholder= { confPantalla.runciccfg.padre.modalresponsable.idage2.placeholder }
                            col=         { confPantalla.runciccfg.padre.modalresponsable.idage2.col } 
                            isClearable= { confPantalla.runciccfg.padre.modalresponsable.idage2.isclearable }
                            isSearchable={ confPantalla.runciccfg.padre.modalresponsable.idage2.issearchable }
                            dataType=    { "url" }
                            data=        { "/agentes/getDirectionType" }
                            appendPost={ [{ key: "step", value: (activeStep +1) }] }
                            modifyOptions={ (options) => {
                                const dataArray = options?.data || options;
                                return Array.isArray(dataArray) ? dataArray.map(opt => ({ value: opt.id, label: opt.nomtab })) : [];
                            } }
                            required=    { confPantalla.runciccfg.padre.modalresponsable.idage2.required } 
                            disabled=    { confPantalla.runciccfg.padre.modalresponsable.idage2.disabled }
                            readOnly =   { confPantalla.runciccfg.padre.modalresponsable.idage2.readonly }
                            disablethisid={confPantalla.runciccfg.padre.modalresponsable.idage2.disablethisid}
                            disableids={ confPantalla.runciccfg.padre.modalresponsable.idage2.disableids}
                            formulario= { {id:0} }   
                            change= { (selectedItem, nameOfComponent) => handleSelectResponsable(selectedItem, nameOfComponent) }
                        />
                        {  loadingUpdateResponsable ? 
                                <div className='mt-4' style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                    <Spinner animation="border" />
                                </div>
                            :
                            null
                        }                                                
                    </Modal.Body>
                    <Modal.Footer>
                        <div className='text-right'>
                            <button 
                                    className="btn btn-success mt-1 mr-1"
                                    onClick={ () => updateResponsable() }
                                    disabled={valResponsable == 0 ? true : false}                                        
                            >
                                {confPantalla.runciccfg.padre.modalresponsable.btnaceptar.title}
                            </button>                            
                        </div>
                    </Modal.Footer>                            
                </Modal>
            :
                null
        }
        {
            showModalPendienteFirma
            ?
                <Modal
                    show={showModalPendienteFirma}
                    onHide={ () => saveShowModalPendienteFirma(false)}
                    aria-labelledby="modal-pendiente-firma-title"
                    centered={true}
                    dialogClassName="modal-90w"
                >
        
                    <PendienteFirmaModalContent
                        confPantalla={confPantalla}
                        context={pendienteFirmaContext}
                        loading={loadingModalNextStep}
                        onCancel={() => saveShowModalPendienteFirma(false)}
                        cicloId = {idCiclo}
                        apiKeyFn={apiKey}
                    />
                </Modal>
            :
                null
        }
        {
            showModalInfoOperacion
            ?
                <Modal
                    show={showModalInfoOperacion}
                    onHide={ () => saveShowModalInfoOperacion(false)}                            
                    aria-labelledby="example-custom-modal-styling-title"
                    centered={true}                    
                    dialogClassName="modal-90w" 
                    >
                    <Modal.Header closeButton>
                        <h4>{confPantalla.runciccfg.padre.modallineas.header.title}</h4>
                    </Modal.Header>                          
                    <Modal.Body>
                        {  loadingTablaInfoOperacion ? 
                                <div className='mt-4' style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                    <Spinner animation="border" />
                                </div>
                            :
                                null
                        }
                        <MiDataTable 
                            estadoForm= { "" }
                            formulario={ {id:0} }
                            id={"tablaInfoOperacion"}
                            columnas={confPantalla.runciccfg.padre.modalinfooperacion.datatableinfooperacion.columns}
                            data={datosTablaInfoOperacion}
                            buttons={confPantalla.runciccfg.padre.modalinfooperacion.datatableinfooperacion.buttons}
                            ordering={confPantalla.runciccfg.padre.modalinfooperacion.datatableinfooperacion.ordering}
                            order={confPantalla.runciccfg.padre.modalinfooperacion.datatableinfooperacion.order}
                            searching={confPantalla.runciccfg.padre.modalinfooperacion.datatableinfooperacion.searching}
                            paging={confPantalla.runciccfg.padre.modalinfooperacion.datatableinfooperacion.paging}
                            select={confPantalla.runciccfg.padre.modalinfooperacion.datatableinfooperacion.select}
                            pagelength={confPantalla.runciccfg.padre.modalinfooperacion.datatableinfooperacion.pagelength}                            
                            columnactions={confPantalla.runciccfg.padre.modalinfooperacion.datatableinfooperacion.columnactions.title}
                            linkColumns={confPantalla.runciccfg.padre.modalinfooperacion.datatableinfooperacion.linkColumns}
                            traduction={confPantalla.config.trad.components.datatable}                                           
                        />
                         <p className="font-italic text-center">{confPantalla.runciccfg.padre.modalinfooperacion.help.title}</p>                   
                        <button type="button" className="mr-2 btn btn-flat btn-danger mt-3 float-right " onClick={ () => saveShowModalInfoOperacion(false) }>
                                {confPantalla.runciccfg.padre.modallineas.btncerrar.title}
                        </button>
                    </Modal.Body>                            
                </Modal>
            :
                    null
        }
        </div>

    );

}
export default RunCicCfg